import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import BusinessOrganizationsPage from "./BusinessOrganizationsPage";
import BusinessSettingsPage from "./BusinessSettingsPage";
import BusinessStoreRatingsPage from "./BusinessStoreRatingsPage";
import BusinessStoresPage from "./BusinessStoresPage";
import SupplierOrgRoutingPage from "./SupplierOrgRoutingPage";
import FinanceReportPage from "./FinanceReportPage";
import FinanceControlPage from "./FinanceControlPage";
import "./OrganizationPage.css";

const pageStyle = {
    padding: "24px",
    display: "grid",
    gap: "18px",
    maxWidth: "1440px",
    margin: "0 auto",
    boxSizing: "border-box",
};

const tabs = [
    { key: "settings", label: "Общие настройки", path: "/organization/settings" },
    { key: "legal-entities", label: "Юрлица и кассы", path: "/organization/legal-entities" },
    { key: "enterprises", label: "Предприятия", path: "/organization/enterprises" },
    { key: "stores", label: "Магазины", path: "/organization/stores" },
    { key: "supplier-routing", label: "Маршрутизация", path: "/organization/supplier-routing" },
    { key: "ratings", label: "Рейтинг", path: "/organization/ratings" },
    { key: "finance", label: "Фин отчет", path: "/organization/finance-report" },
    { key: "finance-control", label: "Финансовый контроль", path: "/organization/finance-control" },
];

const getActiveTab = (pathname) => {
    if (pathname.includes("/legal-entities")) {
        return "legal-entities";
    }
    if (pathname.includes("/enterprises")) {
        return "enterprises";
    }
    if (pathname.includes("/supplier-routing")) {
        return "supplier-routing";
    }
    if (pathname.includes("/stores")) {
        return "stores";
    }
    if (pathname.includes("/competitors")) {
        // Раздел "Конкуренты" свёрнут в подвкладку внутри "Рейтинг" — старая ссылка
        // ведёт на тот же таб (подвкладку пользователь выбирает уже внутри).
        return "ratings";
    }
    if (pathname.includes("/ratings")) {
        return "ratings";
    }
    if (pathname.includes("/finance-report")) {
        return "finance";
    }
    if (pathname.includes("/finance-control")) {
        return "finance-control";
    }
    return "settings";
};

const OrganizationPage = ({ authUser }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const activeTab = getActiveTab(location.pathname);

    if (location.pathname === "/organization") {
        return <Navigate to="/organization/settings" replace />;
    }

    return (
        <div className="organization-page" style={pageStyle}>
            <div className="og-headrow">
                <h1>Организация</h1>
                <span className="crumb">Рабочая зона Business-контура: общие настройки, юрлица, предприятия и магазины</span>
            </div>

            <div className="og-subtabs">
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        className={`og-subtab${activeTab === tab.key ? " active" : ""}`}
                        onClick={() => navigate(tab.path)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {activeTab === "settings" && <BusinessSettingsPage authUser={authUser} embedded />}
            {activeTab === "legal-entities" && <BusinessOrganizationsPage authUser={authUser} embedded />}
            {activeTab === "enterprises" && <BusinessStoresPage authUser={authUser} embedded mode="enterprises" />}
            {activeTab === "stores" && <BusinessStoresPage authUser={authUser} embedded mode="stores" />}
            {activeTab === "supplier-routing" && <SupplierOrgRoutingPage authUser={authUser} embedded />}
            {activeTab === "ratings" && <BusinessStoreRatingsPage authUser={authUser} embedded />}
            {activeTab === "finance" && <FinanceReportPage authUser={authUser} embedded />}
            {activeTab === "finance-control" && <FinanceControlPage embedded />}
        </div>
    );
};

export default OrganizationPage;
